module.exports = __webpack_public_path__ + "img/logo_pingpub.0d418e61.png";